module.exports = __webpack_public_path__ + "img/11.19fbf4f9.png";